import clsx from "clsx";
import { motion } from "framer-motion";
import useDarkMode from "src/hooks/useDarkMode";
import useMobile from "src/hooks/useMobile";

const LoginBackground: React.FC = () => {
  const { isMobile } = useMobile();
  const { isEnabled: isDarkMode } = useDarkMode();

  const waveColors = {
    light: "#1e3a8a",
    dark: "#111827",
  };

  const baseColor = isDarkMode ? waveColors.dark : waveColors.light;

  const topWaves = [
    "M0,0 C100,100 200,0 300,100 C400,200 500,100 600,0 L600,0 L0,0 Z",
    "M0,0 C120,80 240,40 360,100 C480,160 600,60 600,0 L600,0 L0,0 Z",
    "M0,0 C100,100 200,0 300,100 C400,200 500,100 600,0 L600,0 L0,0 Z",
  ];

  const bottomWaves = [
    "M0,300 C100,240 150,360 250,300 C350,240 400,360 500,300 C600,240 600,300 600,300 L600,300 L0,300 Z",
    "M0,300 C120,260 180,360 270,300 C360,240 420,360 520,300 C600,240 600,300 600,300 L600,300 L0,300 Z",
    "M0,300 C100,240 150,360 250,300 C350,240 400,360 500,300 C600,240 600,300 600,300 L600,300 L0,300 Z",
  ];

  return (
    <div
      className={clsx([
        "fixed",
        "inset-0",
        "overflow-hidden",
        "z-10",
        "md:hidden",
        "pointer-events-none",
      ])}
    >
      {/* Top wave */}
      <svg
        className="absolute top-0 right-0 w-full h-1/2"
        viewBox="0 0 600 300"
        preserveAspectRatio="none"
      >
        <motion.path
          fill={baseColor}
          animate={{ d: topWaves }}
          initial={{ d: topWaves[0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        />
      </svg>

      {/* Bottom wave - más alta y con nueva forma */}
      <svg
        className="absolute bottom-0 left-0 w-full h-[60%]"
        viewBox="0 0 600 300"
        preserveAspectRatio="none"
      >
        <motion.path
          fill={baseColor}
          animate={{ d: bottomWaves }}
          initial={{ d: bottomWaves[0] }}
          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
        />
      </svg>
    </div>
  );
};

export default LoginBackground;
